import { Alert, Spinner } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import { Suspense } from 'react';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentList } from '~/features/StressAssessmentList';
import { StressAssessmentScheduleAlert } from '~/features/StressAssessmentScheduleAlert';
import { StressAssessmentScheduleNotificationBanner } from '~/features/StressAssessmentScheduleNotificationBanner';
import { StressAssessmentHeader } from '~/ui/domain/stress-assessment/StressAssessmentHeader';
import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  const { enableStaging } = getEnvFeatureFlag();

  return (
    <div
      className={clsx(styles.screen, {
        [styles.NoSideMenu]: IS_STRESS_CHECK_IMPLEMENTER_BUILD,
      })}
    >
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && <ClientSideMenu />}
      <div className={styles.content}>
        <StressAssessmentHeader showLogoutButton={IS_STRESS_CHECK_IMPLEMENTER_BUILD} />
        {/* 実施者ビルドでは案内先の /contact が WAF で遮断されるため表示しない */}
        {enableStaging && !IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
          <div className={styles.ContactNoticeWrapper}>
            <Alert
              status='info'
              description='実施者（産業医・保健師）向け画面のご利用はお問い合わせください'
              action='お問い合わせ'
              actionLink={ROUTES.CONTACT}
            />
          </div>
        )}
        {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
          <div className={styles.ScheduleAlertWrapper}>
            <Suspense fallback={<Spinner />}>
              <StressAssessmentScheduleAlert />
            </Suspense>
          </div>
        )}
        <Suspense fallback={<Spinner />}>
          <StressAssessmentList />
        </Suspense>
      </div>
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
        <div className={styles.BannerWrapper}>
          <Suspense fallback={null}>
            <StressAssessmentScheduleNotificationBanner />
          </Suspense>
        </div>
      )}
    </div>
  );
};
